import type { ReactNode } from 'react';

export interface PageHeadProps {
  crumbs: string[];
  title: string;
  actions?: ReactNode;
}

export function PageHead({ crumbs, title, actions }: PageHeadProps) {
  return (
    <div className="page-head">
      <div>
        <div className="crumbs">
          {crumbs.map((c, i) => (
            <span key={i}>{c}</span>
          ))}
        </div>
        <h2>{title}</h2>
      </div>
      {actions && <div className="actions">{actions}</div>}
    </div>
  );
}
